import clsx from 'clsx';
import * as React from 'react';

import useStyles from './Skeleton.styles';

export interface ISkeletonProps {
  active?: boolean;
  block?: boolean;
  round?: boolean;
  children: React.ReactNode;
}

const Skeleton: React.FC<ISkeletonProps> = ({
  block,
  round,
  active,
  children,
}) => {
  const classes = useStyles();

  return active ? (
    <div className={clsx(classes.root, round && classes.round)}>
      <span className={clsx((block || round) && classes.block)}>
        {children}
      </span>
    </div>
  ) : (
    <>{children}</>
  );
};

export default Skeleton;
